<template>
  <!-- v-if="(!$isServer && !canRecordInterview) || isXiaomi" -->
  <ClientOnly>
    <AppPreloader v-if="loading" />
    <VacancyContainer
      v-else
      :id="vacancyId"
      v-slot="{ company, vacancy }"
      @ready="handleVacancyContainerReady"
    >
      <VStepper
        v-if="!isDone && !isInterrupted"
        v-model="displayStep"
        alt-labels
        class="transparent elevation-0"
      >
        <VRow justify="center">
          <VCol v-if="!$route.meta.iframe" cols="12" md="3" xl="2" :class="{ 'd-none': currentStep === 6 || currentStep === 2 && (vacancy && vacancy.hasTest) }">
            <CompanySmallCard v-show="$vuetify.breakpoint.smAndDown" :company="company" />
          </VCol>
          <VCol
            cols="12"
            :md="$route.meta.iframe ? 10 : 8"
            :xl="$route.meta.iframe ? 10 : 6"
            :class="{ 'pa-0': $route.meta.iframe }"
          >
            <VRow justify="center">
              <VCol cols="12" lg="10" :class="{ 'pb-0': $route.meta.iframe }">
                <VStepperHeader class="elevation-0 caption text-center stepper-header">
                  <VStepperStep step="1">
                    {{ $t('profile') }}
                  </VStepperStep>
                  <VDivider v-if="vacancy && vacancy.hasTest" />
                  <VStepperStep v-if="vacancy && vacancy.hasTest" step="2">
                    {{ $t('testing') }}
                  </VStepperStep>
                  <VDivider />
                  <VStepperStep :step="vacancy && vacancy.hasTest ? 3 : 2">
                    {{ $t('cameraOn') }}
                  </VStepperStep>
                  <VDivider />
                  <VStepperStep :step="vacancy && vacancy.hasTest ? 4 : 3">
                    {{ $t('micSettings') }}
                  </VStepperStep>
                  <VDivider />
                  <VStepperStep :step="vacancy && vacancy.hasTest ? 5 : 4">
                    {{ $t('cameraSettings') }}
                  </VStepperStep>
                  <VDivider />
                  <VStepperStep :step="vacancy && vacancy.hasTest ? 6 : 5">
                    {{ $t('interview') }}
                  </VStepperStep>
                </VStepperHeader>
              </VCol>
            </VRow>
          </VCol>
        </VRow>
        <VRow
          justify="center"
          :class="{ 'flex-direction-column-reserve': testStarted && testInfo.timer }"
        >
          <VCol
            v-show="$vuetify.breakpoint.mdAndUp && !$route.meta.iframe"
            cols="12"
            md="3"
            xl="2"
            :class="{ 'd-none': currentStep === 6 || (currentStep === 2 && vacancy && vacancy.hasTest) }"
          >
            <CompanySmallCard
              class="mb-4"
              :company="company"
            />
          </VCol>
          <VCol
            cols="12"
            :md="$route.meta.iframe ? 10 : currentStep === 6 ? 12 : 8"
            :xl="$route.meta.iframe ? 10 : currentStep === 6 ? 12 : 6"
            :class="{ 'pt-0': $route.meta.iframe }"
          >
            <VCard
              :elevation="$route.meta.iframe || currentStep === 6 ? 0 : 1"
              :color="
                ($route.meta.iframe && currentStep === 1) || currentStep === 6
                  ? 'transparent'
                  : '#ffffff'
              "
              :class="
                ($route.meta.iframe && currentStep === 1) || currentStep === 6
                  ? 'pa-0 pa-md-0 mb-0'
                  : 'pa-3 pa-md-5 px-md-12 mb-5'
              "
            >
              <PrefetchInterview v-if="vacancy" :vacancy="vacancy" />
              <VStepperItems class="full-screen-item">
                <VStepperContent :step="1" class="pa-0">
                  <CandidateProfileForm
                    :vacancy="vacancy"
                    :candidate="candidate"
                    @done="setStep(vacancy && vacancy.hasTest ? 2 : 3)"
                  />
                </VStepperContent>
                <VStepperContent v-if="vacancy && vacancy.hasTest" :step="2" class="pa-0">
                  <Test
                    v-if="currentStep === 2"
                    :id="vacancyId"
                    :candidate="candidate"
                    :test-info="testInfo"
                    :test-started="testStarted"
                    :test-finished="testFinished"
                    :test-passed="testPassed"
                    :disabled-answers="disabledAnswers"
                    :vacancy="vacancy"
                    @done="setStep(3)"
                    @start="startTest()"
                    @finish="finishTest()"
                    @heightChanged="changeHeight"
                  />
                  <span v-else />
                </VStepperContent>
                <VStepperContent :step="vacancy && vacancy.hasTest ? 3 : 2" class="pa-0">
                  <div v-if="!canRecordInterview">
                    <template v-if="isIOS">
                      <IframeAppIosMessage
                        v-if="$route.meta.iframe"
                        :vacancy-id="vacancyId"
                        :candidate="candidate"
                      />
                      <AppIosMessage v-else :vacancy-id="vacancyId" :candidate="candidate" />
                    </template>
                    <template v-else>
                      <CanNotRecordInterview :cancel-text="$t('back')" @cancel="$router.go(-2)" />
                    </template>
                  </div>
                  <InterviewRequestPermissions
                    v-else-if="displayStep === (vacancy && vacancy.hasTest ? 3 : 2) && canRecordInterview"
                    @done="permissionsGranted"
                  />
                  <span v-else />
                </VStepperContent>
                <VStepperContent :step="vacancy && vacancy.hasTest ? 4 : 3" class="pa-0">
                  <InterviewMicrophoneCheck
                    v-if="displayStep === (vacancy && vacancy.hasTest ? 4 : 3)"
                    :candidate="candidate"
                    @done="setStep(5)"
                  />
                  <span v-else />
                </VStepperContent>
                <VStepperContent :step="vacancy && vacancy.hasTest ? 5 : 4" class="pa-0">
                  <InterviewCameraCheck
                    v-if="displayStep === (vacancy && vacancy.hasTest ? 5 : 4)"
                    @done="setStep(6)"
                  />
                  <span v-else />
                </VStepperContent>
                <VStepperContent :step="vacancy && vacancy.hasTest ? 6 : 5" class="pa-0">
                  <VRow justify="center">
                    <VCol cols="12" md="10" xl="8" class="relative">
                      <ClientOnly>
                        <h1 class="d-none headline text-center mb-6">
                          {{ $t('interviewRecord') }} <i class="dot" />
                        </h1>
                        <div v-if="company.logo" class="interview-avatar">
                          <CompanyAvatar :company="company" :size="50" />
                        </div>
                        <InterviewRecorder
                          v-if="currentStep === 6"
                          :candidate="candidate"
                          :interviewer="vacancy.script.interviewer"
                          :questions="vacancy.script.questions"
                          :vacancy-id="vacancyId"
                          @stopped="stopped"
                          @interrupted="interrupted"
                        />
                      </ClientOnly>
                    </VCol>
                  </VRow>
                </VStepperContent>
              </VStepperItems>
            </VCard>
          </VCol>
          <VCol
            v-if="isTimer"
            cols="12"
            md="2"
          >
            <VCard
              id="stickyElement"
              :elevation="$route.meta.iframe ? 0 : 1"
              :color="'#ffffff'"
              class="pa-3 timer"
            >
              <InterviewTimer
                :timer="testInfo.timer"
                :time-limit="timeLimit"
                @finish="finishTest()"
              />
            </VCard>
          </VCol>
        </VRow>
      </VStepper>
      <InterviewDone v-else-if="isDone" :company="company" :vacancy="vacancy" />
      <InterviewInterrupted v-else-if="isInterrupted" />
      <Portal v-if="!$route.meta.iframe" to="support">
        <SupportTicketDialog
          :candidate="candidate"
        />
      </Portal>
      <SupportTicketDialog
        v-else
        :candidate="candidate"
      />
    </VacancyContainer>
  </ClientOnly>
</template>

<script>
import ClientOnly from 'vue-client-only';
import LogRocket from 'logrocket';
import CanNotRecordInterview
  from '@huntica/huntica-interview-module/src/components/CanNotRecordInterview.vue';
import { canRecordInterview } from '@huntica/huntica-interview-module/src/helpers';
import { initLogRocket } from '@/logrocket';
import PrefetchInterview
  from '@huntica/huntica-interview-module/src/components/PrefetchInterview.vue';
import AppIosMessage from '@/components/AppIosMessage.vue';
import IframeAppIosMessage from '@/components/IframeAppIosMessage.vue';
import { mapState } from 'vuex';
import { candidateStatuses } from '@/enums';
import { isIOS, safeGet } from '@/functions';
import useLocale from '@/compositions/useLocale';
import VacancyContainer from '../components/Vacancy/VacancyContainer.vue';
import CompanySmallCard from '../components/Company/CompanySmallCard.vue';
import CompanyAvatar from '../components/Company/CompanyAvatar.vue';
import CandidateProfileForm from '../forms/CandidateProfileForm.vue';
import InterviewDone from '../components/Interview/InterviewDone.vue';
import InterviewInterrupted from '../components/Interview/InterviewInterrupted.vue';
import AppPreloader from '../components/AppPreloader.vue';
import SupportTicketDialog from '../components/SupportTicketDialog.vue';
import InterviewTimer from '../components/Interview/InterviewTimer.vue';

export default {
  name: 'Interview',
  components: {
    IframeAppIosMessage,
    AppIosMessage,
    AppPreloader,
    CanNotRecordInterview,
    CompanySmallCard,
    CompanyAvatar,
    ClientOnly,
    InterviewDone,
    InterviewInterrupted,
    CandidateProfileForm,
    VacancyContainer,
    PrefetchInterview,
    InterviewTimer,
    InterviewRequestPermissions: process.browser
      ? () => import('../components/Interview/InterviewRequestPermissions.vue')
      : null,
    Test: process.browser
      ? () => import('../components/Test/Test.vue')
      : null,
    InterviewMicrophoneCheck: process.browser
      ? () => import('../components/Interview/InterviewMicrophoneCheck.vue')
      : null,
    InterviewCameraCheck: process.browser
      ? () => import('../components/Interview/InterviewCameraCheck.vue')
      : null,
    SupportTicketDialog,
    InterviewRecorder: process.browser
      ? () => import('../components/Interview/InterviewRecorder.vue')
      : null,
  },
  metaInfo() {
    return {
      title: this.pageTitle,
    };
  },
  props: {
    vacancyId: {
      type: Number,
      required: true,
    },
    step: {
      type: Number,
      required: false,
      default: 1,
    },
  },
  setup() {
    const { setLocaleFromQuery } = useLocale();
    return {
      setLocaleFromQuery,
    };
  },
  data() {
    const savedStep = Number(localStorage.getItem('interviewStep'));
    const initialStep = savedStep && !this.$route.meta.iframe ? savedStep : 1;
    return {
      process: process.browser,
      loading: true,
      pageTitle: null,
      canRecordInterview: process.browser && canRecordInterview(),
      currentStep: initialStep,
      isDone: false,
      isInterrupted: false,
      globalStream: null,
      iframeInterviewDone: false,
      testInfo: {},
      currentVacancy: null,
      hasTestValue: false,
    };
  },
  computed: {
    IOSCode() {
      return this.candidate ? this.candidate.hashId : this.vacancyId;
    },
    candidate() {
      const candidate = safeGet(this.$store.state.candidate, ['data', 'candidate']);

      if (!candidate || candidate.vacancyId !== this.vacancyId) {
        return null;
      }

      return candidate;
    },
    candidateVacancy() {
      if (!this.candidate) {
        return null;
      }
      return safeGet(this.$store.state.candidate, ['data', 'vacancy']);
    },
    disabledAnswers() {
      if (!this.testInfo) {
        return false;
      }

      return !!(this.testInfo.timer && this.timeLimit <= 0);
    },
    isIOS() {
      return isIOS();
    },
    hasTest() {
      return !!this.currentVacancy?.hasTest;
    },
    stepCameraOn() {
      return this.hasTestValue ? 3 : 2;
    },
    stepMicSettings() {
      return this.hasTestValue ? 4 : 3;
    },
    stepCameraSettings() {
      return this.hasTestValue ? 5 : 4;
    },
    stepInterview() {
      return this.hasTestValue ? 6 : 5;
    },
    displayStep: {
      get() {
        if (!this.hasTestValue) {
          if (this.currentStep >= 3) {
            return this.currentStep - 1;
          }
        }
        return this.currentStep;
      },
      set(value) {
        if (!this.hasTestValue) {
          if (value >= 2) {
            this.currentStep = value + 1;
          } else {
            this.currentStep = value;
          }
        } else {
          this.currentStep = value;
        }
      },
    },
    isShowStep() {
      return !!(this.candidate && (!this.testInfo || this.testPassed));
    },
    isTimer() {
      return this.currentStep === 2
        && this.testStarted && this.testInfo.timer && !this.testFinished;
    },
    testFinished() {
      return !!this.candidate?.testFinishedAt;
    },
    testPassed() {
      return !!this.candidate?.testScore?.passed;
    },
    testStarted() {
      return !!this.candidate?.testStartedAt;
    },
    timeLimit() {
      if (!this.candidate?.testStartedAt && !this.testInfo) {
        return 0;
      }
      const testTimerSeconds = this.testInfo.timer * 60;
      const currentDate = new Date().getTime();
      const testStartedDate = new Date(this.candidate?.testStartedAt).getTime();
      const timeLimit = Math.floor(
        (testTimerSeconds - (currentDate - testStartedDate) / 1000),
      );

      if ((timeLimit >= testTimerSeconds)) {
        return testTimerSeconds;
      }

      return timeLimit;
    },
    ...mapState('vacancy', ['vacancy']),
  },
  watch: {
    currentStep(step) {
      this.calculateHeight();

      if (step === 2 && !this.testFinished && this.testStarted && this.$route.meta.iframe) {
        window.parent.postMessage('huntica-interview-test-step', '*');
        window.addEventListener('scroll', () => this.handleScrollTimer());
      }

      if (step === 6 && this.$route.meta.iframe) {
        return window.parent.postMessage('huntica-interview-video-step', '*');
      }
    },
    iframeInterviewDone() {
      return window.parent.postMessage('huntica-interview-done', '*');
    },
    testStarted(newValue, oldValue) {
      if (oldValue) {
        return;
      }
      if (!oldValue && newValue) {
        window.addEventListener('scroll', () => this.handleScrollTimer());
      }
    },
    testFinished(newValue) {
      if (newValue) {
        window.removeEventListener('scroll', () => this.handleScrollTimer());
      }
    },
  },
  beforeCreate() {
    initLogRocket(this.$route.query.disableLogRocket);
  },
  updated() {
    this.changeHeight();
  },
  async created() {
    if (localStorage.getItem(`vacancy_${this.vacancyId}_current_candidate`)) {
      await this.$store.dispatch('candidate/fetchData', {
        vacancyId: this.vacancyId,
      });
    }

    if (this.candidate) {
      await this.fetchTestData();
    }

    if (this.candidate) {
      LogRocket.identify(this.candidate.id, {
        name: `${this.candidate.firstName} ${this.candidate.lastName}`,
        email: this.candidate.email,
        phone: this.candidate.phone,
        authType: 'candidate',
      });
    }

    if (this.$route.params.isIosDevice) {
      await this.setStep(3);
    }

    this.loading = false;

    if (!canRecordInterview()) {
      return null;
    }

    if (this.candidate
      && this.candidate.status !== candidateStatuses.INVITED
      && this.candidate.status !== candidateStatuses.IMPORTED
      && this.candidate.status !== candidateStatuses.TESTED) {
      return this.$router.push({
        name: this.$route.meta.iframe ? 'iframeInterviewResult' : 'interviewResult',
        params: {
          companyId: this.candidateVacancy.companyId,
          vacancyId: this.candidateVacancy.id,
        },
      });
    }

    if (this.candidate && this.candidate.interview) {
      return this.$router.push({
        name: this.$route.meta.iframe ? 'iframeInterviewContinue' : 'interviewContinue',
        params: {
          companyId: this.candidateVacancy.companyId,
          vacancyId: this.candidateVacancy.id,
        },
      });
    }

    return null;
  },
  methods: {
    permissionsGranted() {
      this.setStep(4);
    },
    stopped() {
      if (this.$route.meta.iframe) {
        this.iframeInterviewDone = true;
      } else {
        this.isDone = true;
      }
    },
    calculateHeight() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = document.querySelector('.container');
          if (!container) {
            return;
          }
          let height = container.offsetHeight;
          if (height < 500) height = 700;
          // eslint-disable-next-line no-restricted-globals
          parent.postMessage({ height }, '*');
        }, 1000);
      });
    },
    interrupted() {
      this.isInterrupted = true;
    },
    handleVacancyContainerReady({ vacancy }) {
      this.currentVacancy = vacancy;
      this.hasTestValue = !!vacancy.hasTest;
      this.pageTitle = `${this.$t('pageTitle')} ${vacancy.title}`;
      
      this.setLocaleFromQuery(this.$route);
      
      if (this.currentStep === 2 && !vacancy.hasTest) {
        this.currentStep = 3;
        localStorage.setItem('interviewStep', 3);
      }
    },
    async setStep(val) {
      if (val === 2 && this.currentVacancy && !this.currentVacancy.hasTest) {
        val = 3;
      }

      if (val === 3 && this.isIOS) {
        await this.$router.push({
          name: 'candidatePersonalIosStubLink',
          params: {
            hashId: this.hashId || this.candidate?.hashId,
          },
        });

        return;
      }

      if (val === 2) {
        this.loading = true;
        await this.fetchTestData();
      }

      this.currentStep = val;

      if (val === 3) {
        await this.$store.dispatch('candidate/markCandidateSetupStarted', {
          candidateId: this.candidate.id,
        });
      }
      localStorage.setItem('interviewStep', val);

      this.calculateHeight();
    },
    async startTest() {
      this.loading = true;
      window.parent.postMessage('huntica-interview-test-step', '*');
      await this.$store.dispatch('candidate/startTest');
      await this.$store.dispatch('candidate/fetchData', { vacancyId: this.candidate.vacancyId });
      this.loading = false;
      // this.calculateHeight();
    },
    async finishTest() {
      this.loading = true;
      window.parent.postMessage('huntica-interview-test-done', '*');
      await this.$store.dispatch('candidate/finishATest');
      await this.$store.dispatch('candidate/fetchData', { vacancyId: this.candidate.vacancyId });
      this.loading = false;
      this.calculateHeight();
    },
    async fetchTestData() {
      this.loading = true;
      if (!this.candidate) {
        await this.$store.dispatch('candidate/fetchData', { vacancyId: this.candidate.vacancyId });
      }

      if (this.candidate.testId) {
        this.testInfo = await this.$store.dispatch(
          'vacancy/fetchTestById', {
            vacancyId: this.vacancyId,
            testId: this.candidate.testId,
          },
        );
      } else {
        this.testInfo = await this.$store.dispatch('vacancy/fetchTest', this.vacancyId);
      }
      this.loading = false;
    },
    handleScrollTimer() {
      const scrollPosition = document.documentElement.scrollTop;
      const element = document.getElementById('stickyElement');
      if (!element) {
        return;
      }

      if (scrollPosition >= 100) {
        element.classList.add('fixed');
      }

      if (scrollPosition <= 130) {
        element.classList.remove('fixed');
      }
    },
    changeHeight() {
      if (this.$route.meta.iframe) {
        this.calculateHeight();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  display: inline-block;
  background: red;
  position: relative;
  top: -10px;
}

.interview-avatar {
  width: 60px;
  height: 60px;
  margin: 5px;
  position: absolute;
  left: 15px;
  top: 15px;
  z-index: 2;
}

.timer {
  min-width: 145px;
  max-width: 145px;
  will-change: transform;
  @media screen and (max-width: 768px) {
    max-width: 100%;
  }
}

.fixed {
  position: fixed;
  margin-top: 10px;
  top: 0;
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .interview-avatar {
    left: 30px;
    top: 30px;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-down')} {
  .timer {
    width: 100%;
  }
  .flex-direction-column-reserve {
    flex-direction: column-reverse;
  }
}

.stepper-header {
  &::v-deep {
    .v-stepper__label {
      text-align: center;
    }

    .v-divider {
      border-style: dotted;
      margin-top: 37px;
    }

    .v-stepper__step {
      flex-basis: 130px;

      .v-stepper__step__step {
        background: #fff !important;
        color: map-get($grey, 'lighten-1');
        font-size: 14px !important;
      }

      &.v-stepper__step--active {
        .v-stepper__step__step {
          background: map-get($blue, 'base') !important;
          color: #fff;
        }
      }
    }
  }
}

.interview-button-close {
  position: absolute;
  bottom: 5px;
  z-index: 999;
  button {
    @media screen and (max-width: 480px) {
      height: 27px !important;
      font-size: 11px !important;
    }
    @media screen and (max-width: 340px) {
      height: 27px !important;
      font-size: 9px !important;
    }
  }
}
</style>

<style lang="scss" scoped>
.chip {
  padding: 0 12px;
  border-radius: 5px;
  background-color: rgba(92, 187, 246, 0.2);
  font-size: 1.25rem;
}
</style>

<style lang="scss">
.interview-iframe .v-text-field--outlined .v-input__slot {
  background-color: white !important;
}
</style>

<i18n locale="en" lang="yaml">
  browserListTip: "Use one of the browsers listed below:"
  back: Go back
  profile: personal data
  testing: testing
  cameraOn: permissions
  micSettings: mic setup
  cameraSettings: camera setup
  interview: interview
  interviewRecord: Record interview
  pageTitle: Video interview for the job
  close: Complete the interview
</i18n>

<i18n locale="ru" lang="yaml">
  browserListTip: >-
    Для прохождения видео-интервью необходимо воспользоваться последней
    версией одного из следующих браузеров
  back: Назад
  profile: профиль
  testing: тестирование
  cameraOn: включите камеру
  micSettings: настройка микрофона
  cameraSettings: настройка камеры
  interview: интервью
  interviewRecord: Запись видео-интервью
  pageTitle: Видео-интервью на вакансию
  close: Завершить
</i18n>
